import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { STAMMDATEN_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { costCenterColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiCostCenter } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { CostCentersRepository } from '@Repositories/Stammdaten';

export function FrameListCostCenter() {
    const hasPermission = useHasPermission();

    const module = useListApi(CostCentersRepository, STAMMDATEN_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiCostCenter>
            layoutSettingsContext={EnumFrontendLayoutSetting.CostCentersTableLayout}
            name="CostCenterList"
            columns={costCenterColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.StammdatenCostCenterCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
